import { setDataValue } from '../../form-sync';

export default {
    setDataValue,
};
